// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".slogan[data-v-e94e51d4] {\n  min-height: 150px;\n}\n.label__content[data-v-e94e51d4] {\n  background-color: #F9DF8E !important;\n  color: #010A11;\n}\n.label[data-v-e94e51d4] {\n  position: absolute;\n  top: -15px;\n  left: 0;\n  right: 0;\n}\n.label__content[data-v-e94e51d4] {\n  letter-spacing: 0.75px;\n}\n.label__bg-secondary[data-v-e94e51d4] {\n  background-color: #f900fe;\n}", ""]);
// Exports
module.exports = exports;
